<template>
  <div class="">
    
    <!-- 查询表单 -->
    <div>
      <el-form ref="clerkProgramForm" :model="clerkProgramForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6">
            <el-form-item label="创建时间">
              <el-date-picker clearable
                v-model="clerkProgramForm.createTime"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="商户">
             <el-input clearable v-model="clerkProgramForm.merchantLike"  placeholder="请输入商户姓名或ID"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="门店">
             <el-input clearable v-model="clerkProgramForm.storeLike"  placeholder="请输入门店姓名或ID"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="手机号">
              <el-input clearable v-model="clerkProgramForm.phone" placeholder="请输入手机号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="店员">
             <el-input clearable v-model="clerkProgramForm.userLike"  placeholder="请输入店员姓名或ID"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
         <el-col :span="3">
            <el-button type="primary" @click="getClerkList">查询</el-button>
            <el-button type="primary" @click="addCtiy">添加</el-button>
          </el-col>
          <el-col :span="4">
              <el-button type="primary" style="margin-left:6px" @click="exportExcelData">批量导出</el-button>
              <el-upload
                      style="display:inline"
                      action="aa"
                      :show-file-list="false"
                      :before-upload="importUser">
                <el-button style="margin-left:10px" type="primary" v-loading="fullscreenLoading">批量导入</el-button>
                </el-upload>
           </el-col>
        <el-col :span="4" style="margin-top:10px">
            <a  type="primary" style="margin: 0 10px" @click="getClerkTemplate">导入模板下载</a>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
            <!-- 表格 -->
       <el-table
        :data="tableData"
        border
        style="width: 100%">
          <el-table-column
            prop="code"
            label="店员ID">
          </el-table-column>
          <el-table-column
            prop="realName"
            label="店员姓名">
          </el-table-column>
          <el-table-column
            prop="phone"
            label="店员手机号">
          </el-table-column>
          <el-table-column
            prop="password"
            label="密码">
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            prop="storeName"
            label="所属门店">
          </el-table-column>
          <el-table-column
            prop="merchantName"
            label="所属商户">
          </el-table-column>
          <el-table-column
            prop="roleName"
            label="店员身份">
          </el-table-column>
          <el-table-column
            prop="status"
            label="账号状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 1">已启用</span>
              <span v-else>已禁用</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作">
              <template slot-scope="scope">
                <el-button @click="editorCity(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="openCity(scope.row.id)" type="text" size="small" v-if="scope.row.status === 0">开启</el-button>
                <el-button @click="closeCity(scope.row.id)" type="text" size="small" style="color: red;" v-else>关闭</el-button>
                 <el-button @click="deleteUser(scope.row.id)" type="text" size="small" style="color: gray;">删除</el-button>
              </template>
          </el-table-column>
      </el-table>
      

      <!-- 分页 -->
      <el-pagination style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal">
      </el-pagination>
    </div>

    <!-- 修改或新建店员对话框 -->
    <el-dialog :title="dlgType === 'change' ? '编辑店员' : '新建店员'" :visible.sync="isDlg" width="700px">
      <div style="margin: 20px;">
        <div>
          <el-form ref="editClerkForm" :rules="editorFormRules" :model="editClerkForm" label-width="100px">
            <el-form-item label="店员ID" v-if="dlgType === 'change'" >
              <el-input clearable v-model="editClerkForm.code" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="店员姓名" prop="realName">
              <el-input clearable v-model="editClerkForm.realName"></el-input>
            </el-form-item>
            <el-form-item label="店员身份证" prop="idcard">
              <el-input clearable v-model="editClerkForm.idcard"></el-input>
            </el-form-item>
            <el-form-item label="店员手机号" prop="phone">
              <el-input clearable v-model="editClerkForm.phone"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input clearable v-model="editClerkForm.password"></el-input>
            </el-form-item>
            <el-form-item label="所属商户" prop="merchantLike">
              <el-select clearable
                v-model="editClerkForm.merchantLike"
                filterable
                remote
                placeholder="请输入关键词"
                reserve-keyword
                :remote-method.sync="getMerchantList"
                :loading="Merchantloading"
                @change="getStoreListByMerchantId()">
                <el-option
                  v-for="item in MerchantOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属门店" prop="storeId">
              <el-select clearable
                v-model="editClerkForm.storeId"
                filterable
                remote
                placeholder="请输入关键词"
                reserve-keyword
                :loading="Storeloading">
                <el-option
                  v-for="item in StoreOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="店员身份" prop="storeManager">
               <el-select clearable
                v-model="editClerkForm.storeManager">
                <el-option label="店员" :value="0"></el-option>
                <el-option label="店长" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button type="primary" style="margin: 30px 20px;" @click="submitEditor">确定</el-button>
          <el-button style="margin: 10px 20px;" @click="closeEditorCityDlg">暂不</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  components:{},
  props:{},
  data(){
    return {
      // 查询数据
      clerkProgramForm: {
        createTime: [],
        userLike: '',
        merchantLike: '',
        storeLike: '',
        phone:null
      },

      // 日期选择插件配置
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,


      // 新建编辑对话框数据

      isDlg: false,
      editClerkForm: {
        id: null,
        type: 4,
        idcard: null,
        code: null,
        realName: null,
        phone: null,
        password: null,
        merchantLike: null,
        storeId: null,
        storeManager: null,
      },

      editorFormRules: {
        realName: [
          { required: true, message: '请输入店员姓名', trigger: 'change' },
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'change' },
        ],
        password: [
          { required: true, message: '请输入账号密码', trigger: 'change' },
        ],
        idcard: [
          { required: true, message: '请输入店员身份证', trigger: 'change' },
        ],
        merchantLike: [
          { required: true, message: '请选择所属商户', trigger: 'change' },
        ],
        storeId: [
          { required: true, message: '请选择所属门店', trigger: 'change' },
        ],
        storeManager: [
          { required: true, message: '请选择所属门店', trigger: 'change' },
        ],
      },

      dlgType: 'change',

      StoreOptions: [],
      MerchantOptions: [],
      Storeloading: false,
      Merchantloading: false,
      fullscreenLoading: false,
      
    }
  },
  watch:{},
  computed:{},
  methods:{
          // click事件
    exportExcelData () {
      let self = this
       self.$api
        .getClerkListSearch({
          type: 4,
          page: self.currentPage,
          size: self.pageSize,
          phone: self.clerkProgramForm.phone || null,
          userLike: self.clerkProgramForm.userLike || null,
          merchantLike: self.clerkProgramForm.merchantLike || null,
          storeLike: self.clerkProgramForm.storeLike || null,
          createTimeStart: self.clerkProgramForm.createTime instanceof Array && self.clerkProgramForm.createTime.length>1 ? self.clerkProgramForm.createTime[0] + ' 00:00:00' : null,
          createTimeEnd: self.clerkProgramForm.createTime instanceof Array && self.clerkProgramForm.createTime.length>1 ? self.clerkProgramForm.createTime[1] + ' 23:59:59' : null,
        })
        .then((res) => {
          var downLoadTableData = res.data || [];
          require.ensure([], () => {
                const { export_json_to_excel } = require("@/vender/Export2Excel");
                const fieldName =["店员ID","姓名","手机","角色","店员状态","商户名称","商户联系人","商户电话","商户状态","门店名称","门店联系人","门店电话","门店状态"];
                const filterVal = ["code", "realName", "phone", "roleName","status","merchantName","merchantPerson","merchantPhone", "merchantStatus", "storeName", "storePerson", "storePhone", "storeStatus"];
                const data = downLoadTableData.map(v => filterVal.map(j => {
                  if(j=="status"||j=="merchantStatus"||j=="storeStatus"){
                    return v[j]==1?"已启用":"已禁用"
                  }
                  return v[j]
                }));
                export_json_to_excel(fieldName, data, "店员信息"+self.$moment(new Date()).format("YYYYMMDDHH:mm:ss"));
              });
        });
    },
    getClerkTemplate(){
        window.open((process.env.NODE_ENV === "development" ? "/api2": "")+`/api/sys/user/getClerkTemplate`,"_blank")
    },
          //删除用户
    deleteUser(id){
      let self = this
        self.$confirm('是否删除').then(() => {
         self.$api.deleteUser({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getClerkList()
          }
      })
      })
     
    },
      // 分页函数
    handleSizeChange(val) {
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1)
    },
    handleCurrentChange(val) {
      this.currentPage = val

      // 重新请求订单数据
      this.getClerkList()
    }, 

    // 获取订单数据
    getClerkList() {
      let self  = this;
      self.$api.getUserList({
        type: 4,
        page: self.currentPage,
        size: self.pageSize,
        phone: self.clerkProgramForm.phone || null,
        userLike: self.clerkProgramForm.userLike || null,
        merchantLike: self.clerkProgramForm.merchantLike || null,
        storeLike: self.clerkProgramForm.storeLike || null,
        createTimeStart: self.clerkProgramForm.createTime instanceof Array && self.clerkProgramForm.createTime.length>1 ? self.clerkProgramForm.createTime[0] + ' 00:00:00' : null,
        createTimeEnd: self.clerkProgramForm.createTime instanceof Array && self.clerkProgramForm.createTime.length>1 ? self.clerkProgramForm.createTime[1] + ' 23:59:59' : null,
      }).then(res => {

        self.tableData = res.data.records || []
        self.tableTotal = res.data.total
      })
    },

    // 添加店员
    addCtiy() {
      this.dlgType = 'new'
      this.editClerkForm = {
        id: null,
        type: 4,
        idcard: null,
        code: null,
        realName: null,
        phone: null,
        password: null,
        merchantLike: null,
        storeId: null,
        storeManager: null,
      },
      this.$nextTick(()=>{
          this.$refs['editClerkForm'].clearValidate()
      })
      this.isDlg = true
    },

    // 修改店员
    editorCity(row) { 
      console.log(row);
      this.dlgType = 'change'

      for(let i in this.editClerkForm) {
        if(i === 'storeManager') {
          this.editClerkForm[i] = row.roleName === '店员' ? 0 : 1
        } else if(i === 'merchantLike') {
          this.editClerkForm[i] = row.merchantCode
        } else if(i !== 'type' ) {
          this.editClerkForm[i] = row[i]
        }
      }
      console.log(this.editClerkForm);
      this.isDlg = true
    },

    // 关闭编辑对话框
    closeEditorCityDlg() {
      this.isDlg = false
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;

      this.$refs['editClerkForm'].validate((valid) => {
        if (valid) {
          if(self.dlgType === 'change') {
            self.$api.changeUser(self.editClerkForm).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.getClerkList()
                this.closeEditorCityDlg()
              }
            })
          } else {
            self.$api.addUser(self.editClerkForm).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                this.getClerkList()
                this.closeEditorCityDlg()
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
      
    },


    // 关闭店员
    closeCity(id) {
      this.$api.closeUser(id, {
        userId: id
      }).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '关闭成功',
            type: 'success'
          });
          this.getClerkList()
        }
      })
    },

    // 开启店员
    openCity(id) {
      this.$api.openUser(id, {
        userId: id
      }).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '开启成功',
            type: 'success'
          });
          this.getClerkList()
        }
      })
    },

    // 请求门店
    getStoreListByMerchantId() {
      let self = this;
      self.StoreOptions=[]
      self.editClerkForm.storeId=null
      self.$api.getStoreListByMerchantId({
        merchantId: self.editClerkForm.merchantLike,
      }).then(res => {
        if(res.code === 200) {
          self.StoreOptions = res.data
        }
      
      })
    },

    // 请求门店
    getMerchantList(param) {
      let self = this;
      self.$api.getMerchantList({
        merchantLike: param,
        page: 1,
        size: 100000,
      }).then(res => {
        if(res.code === 200) {
          self.MerchantOptions = res.data.records
        }
      
      })
    },

    // 批量导入
    importUser(file) {
      this.fullscreenLoading = true
      let formData = new FormData()
      formData.append('file', file)
      this.$api.importUser(formData).then(res => {
        this.fullscreenLoading  = false
        if(res.code === 200) {
          // self.StoreOptions = res.data.records
          this.$message({
            message: '导入成功',
            type: 'success'
          });
          this.getClerkList()
        }
      })

      return false
    },
  },
  created(){},
  mounted(){
    let self = this;
    self.getClerkList()
    self.getMerchantList()
  }
}
</script>
<style lang="less" scoped>
</style>